module.exports = __webpack_public_path__ + "static/media/leaveUp.8a237271.svg";